import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, Heart, ShoppingBag, Menu, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const NAV_GROUPS = [{
  label: 'ABOUT',
  href: '/about-us',
  items: [{
    label: 'About Us',
    href: '/about-us'
  }, {
    label: 'Contact Now',
    href: '/contact'
  }]
}, {
  label: 'SERVICES',
  href: '/service'
}, {
  label: 'INSPIRATION',
  href: '/inspiration'
}, {
  label: 'SHOP',
  href: '/rental-shop',
  items: [{
    label: 'Rental Shop',
    href: '/rental-shop'
  }, {
    label: 'Shop Products',
    href: '/shop-products'
  }]
}];
export function Navbar() {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <nav className="w-full bg-white sticky top-0 z-50 shadow-sm border-b border-gray-100" data-id="element-59">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 h-20 lg:h-18 flex items-center justify-between" data-id="element-60">
        {/* Logo */}
        <Link to="/" className="flex flex-col items-start leading-none hover:opacity-80 transition-opacity" data-id="element-61">
          <span className="font-script text-[28px] md:text-[36px] lg:text-[44px] text-black -mb-1" data-id="element-62">
            Chyne Designs
          </span>
          <span className="text-[6px] md:text-[7px] lg:text-[8px] uppercase tracking-[0.1em] lg:tracking-[0.15em] font-bold text-gray-400" data-id="element-63">
            ELEGANT EVENTS & RENTALS LLC
          </span>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-12" data-id="element-64">
          {NAV_GROUPS.map(group => <div key={group.label} className="relative h-28 flex items-center" onMouseEnter={() => setActiveDropdown(group.label)} onMouseLeave={() => setActiveDropdown(null)} data-id="element-65">
              <Link to={group.href} className="text-[13px] font-black uppercase tracking-widest text-gray-900 hover:text-[#b22222] transition-colors flex items-center gap-1.5" data-id="element-66">
                {group.label}
                {group.items && <ChevronDown size={14} className={`text-gray-400 transition-transform duration-300 ${activeDropdown === group.label ? 'rotate-180' : ''}`} data-id="element-67" />}
              </Link>

              <AnimatePresence data-id="element-68">
                {group.items && activeDropdown === group.label && <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: 10
            }} transition={{
              duration: 0.2
            }} className="absolute top-full left-0 w-56 bg-white shadow-xl border border-gray-100 py-4 z-50" data-id="element-69">
                    {group.items.map(item => <Link key={item.label} to={item.href} className="block px-6 py-3 text-[11px] font-bold uppercase tracking-widest text-gray-600 hover:text-[#b22222] hover:bg-gray-50 transition-all" data-id="element-70">
                        {item.label}
                      </Link>)}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        {/* Icons */}
        <div className="flex items-center gap-2 sm:gap-4 md:gap-6" data-id="element-71">
          <button className="hidden sm:block p-1 hover:text-[#b22222] transition-colors" data-id="element-72">
            <Search size={20} strokeWidth={2.5} data-id="element-73" />
          </button>
          <button className="hidden sm:block p-1 hover:text-[#b22222] transition-colors relative" data-id="element-74">
            <Heart size={20} strokeWidth={2.5} data-id="element-75" />
            <span className="absolute -top-1 -right-2 bg-black text-white text-[8px] font-bold w-3.5 h-3.5 rounded-full flex items-center justify-center" data-id="element-76">
              0
            </span>
          </button>
          <button className="p-1 hover:text-[#b22222] transition-colors relative" data-id="element-77">
            <ShoppingBag size={20} strokeWidth={2.5} data-id="element-78" />
            <span className="absolute -top-1 -right-2 bg-black text-white text-[8px] font-bold w-3.5 h-3.5 rounded-full flex items-center justify-center" data-id="element-79">
              0
            </span>
          </button>
          <button className="lg:hidden p-2 -mr-1" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-80">
            <Menu size={22} data-id="element-81" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-82">
        {isMobileMenuOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="lg:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-83">
            <div className="flex flex-col p-6 space-y-6" data-id="element-84">
              {NAV_GROUPS.map(group => <div key={group.label} className="space-y-4" data-id="element-85">
                  <Link to={group.href} onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-black uppercase tracking-widest text-gray-900 block" data-id="element-86">
                    {group.label}
                  </Link>
                  {group.items && <div className="pl-4 flex flex-col space-y-3 border-l border-gray-100" data-id="element-87">
                      {group.items.map(item => <Link key={item.label} to={item.href} onClick={() => setIsMobileMenuOpen(false)} className="text-[11px] font-bold uppercase tracking-widest text-gray-500 hover:text-[#b22222] transition-colors" data-id="element-88">
                          {item.label}
                        </Link>)}
                    </div>}
                </div>)}
              <div className="pt-6 border-t border-gray-100" data-id="element-89">
                <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)} data-id="element-90">
                  <button className="w-full bg-[#b22222] text-white py-4 text-[10px] font-bold uppercase tracking-widest hover:bg-[#8b0000] transition-colors" data-id="element-91">
                    Book a Consultation
                  </button>
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}